import React from 'react';
import { motion } from 'framer-motion';
import { FaWhatsapp } from 'react-icons/fa';

const Header = () => {
  const whatsappNumber = '+573153283570';
  const whatsappLink = `https://wa.me/${whatsappNumber.replace(/\+/g, '')}`;

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <motion.header
      className="bg-white shadow-md py-4 px-6 sticky top-0 z-50"
      initial={{ y: -100, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ type: "spring", stiffness: 120, damping: 14, delay: 0.5 }}
    >
      <div className="container mx-auto flex justify-between items-center">
        <motion.div
          className="text-2xl font-bold text-gray-800"
          initial={{ x: -50, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ delay: 0.7 }}
        >
          Asesoría <span className="text-blue-600">Seguridad Social</span>
        </motion.div>
        <nav className="hidden md:flex items-center space-x-8">
          <motion.button
            onClick={() => scrollToSection('planes-asesoria')}
            className="text-gray-700 hover:text-blue-600 font-semibold transition duration-300"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            Nuestros Planes
          </motion.button>
          <motion.a
            href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-green-500 hover:bg-green-600 text-white font-bold py-2 px-5 rounded-full shadow-lg flex items-center transition duration-300 ease-in-out transform hover:scale-105"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <FaWhatsapp className="mr-2 text-lg" />
            WhatsApp
          </motion.a>
        </nav>
        {/* Aquí podrías agregar un botón de menú para móviles si lo necesitas */}
      </div>
    </motion.header>
  );
};

export default Header;